module.exports = {
      id: "warning-usage",
      viewBox: "0 0 128.1 463.3",
      url: __webpack_public_path__ + "img/icons.05c569e2.svg#warning-usage",
      toString: function () {
        return this.url;
      }
    }